<template>
  <div class="design-width content blog">
    <div class="blog__headline">
      <h1>Impact</h1>
    </div>
    <ul class="blog__cats">
      <li
        v-for="cat in categories"
        :key="cat.id"
        :class="{ active: filterCategory === cat.id }"
      >
        <a href="#" @click.prevent="filterByCategory(cat.id)">
          {{ cat.title }}
        </a>
      </li>
    </ul>
    <div class="blog__grid-wrap">
      <div class="blog__grid">
        <BlogItem v-for="post in filteredPosts" :key="post.slug" :post="post" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { ax, baseURL } from '../js/api';
import {pageMeta, pageTitle} from '../js/meta';
import BlogItem from '../components/blog-item.vue';

export default defineComponent({
  metaInfo: pageMeta({ title: pageTitle('Impact') }),
  components: {
    BlogItem,
  },
  data: function () {
    return {
      posts: [],
      categories: [],
      filterCategory: null,
    };
  },
  computed: {
    filteredPosts() {
      if (this.filterCategory) {
        return this.posts.data.filter((post) =>
          post.categories.some((cat) => cat.id === this.filterCategory)
        );
      }
      return this.posts.data;
    },
  },
  methods: {
    filterByCategory(categoryId) {
      if (this.filterCategory === categoryId) {
        this.filterCategory = null;
        return;
      }
      this.filterCategory = categoryId;
    },
  },
  created() {
    ax.get(`${baseURL}/api/blog`)
      .then((response) => {
        this.posts = response.data;
      })
      .catch(function (error) {
        //console.error(error);
      });
    ax.get(`${baseURL}/api/categories/blog`)
      .then((response) => {
        this.categories = response.data.data;
      })
      .catch(function (error) {
        //console.error(error);
      });
  },
});
</script>

<style lang="scss">
@import '../styles/_toolbox';

.blog {
  font-size: 1rem;

  &__headline {
    padding: 1em 0 1em 0;
    text-align: center;
    font-size: 12rem;
    text-transform: uppercase;
  }

  &__cats {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 0.75em;
    margin-bottom: 4em;
    margin-left: auto;
    max-width: 50em;

    li {
      a {
        display: block;
        text-decoration: none;
        color: var(--c-text);
        font-size: 1.5em;
        border: 1px solid var(--c-brand);
        padding: 0.4em 0.75em;
        color: var(--c-brand);
        border-radius: 2em;
        transition: color 0.2s ease, background-color 0.2s ease;

        &:hover {
          background-color: var(--c-brand);
          color: #fff;
        }
      }
      &.active a {
        background-color: var(--c-brand);
        color: #fff;
      }
    }
  }

  &__grid {
    display: grid;
    grid-gap: 1px;
    grid-template-columns: repeat(12, 1fr);
  }

  @include viewport(from-tablet) {
    .blog__item:nth-child(5n + 1) {
      grid-row: span 1;
      grid-column: span 6;
      flex-direction: row;

      figure {
        width: 40%;
        margin-bottom: 0;
      }
      .blog__item__content {
        width: 50%;
        margin-left: 2rem;
      }
    }
  }

  @include viewport(phone) {
    font-size: 1.5rem;

    &__headline {
      font-size: 6rem;
    }
    &__cats {
      li {
        a {
          font-size: 1.25em;
        }
      }
    }
  }
}
</style>
